export default {
  projectData: {
    data: {},
    isLoading: true,
    error: "",
    listener: () => {},
    noOfLoadings: 0,
  },
}
